import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import(
                './member-response-portal/member-response-portal.module'
            ).then((m: any) => m.MemberResponsePortalModule),
    },
    {
        path: '**',
        redirectTo: ''
    },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
